import $ from 'jquery';

const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-nav-trigger');
    const $mobileMenu = $('.mobile-nav');
    const activeClass = 'is-active';
    const bodyActiveClass = 'mobile-menu-is-active';

    if ($trigger.length) {
        $trigger.on('click', function () {
            $(this).toggleClass(activeClass);
            $mobileMenu.toggleClass(activeClass);
            $('body').toggleClass(bodyActiveClass);
            $('.c-mobile-search input[type="text"]').val('');
            $('html, body').animate({ scrollTop: 0 }, 100);
        });
    }
};

// doc ready
$(() => {
    mobileMenuTriggerInit();
});
